import { useRecoilValue } from "recoil"
import { Flex } from "@chakra-ui/layout"
import { useHistory } from "react-router-dom"
import { BiArrowBack } from "react-icons/bi"

import { Routes } from "../../../constants"
import { brandingSelector } from "../../../recoil/atoms/room"
import { navigatedFromShowListAtom } from "../../../recoil/atoms/shows"
import { joinButtonLoadingSelector } from "../../../recoil/atoms/joinButton"
import { navigatedFromAvatarsListAtom } from "../../../recoil/atoms/avatars"
import { FC } from "react"
import { ConsoleLogger } from "../../../util/logger"
import React from "react"
import { SDKContext } from "../../../context/SDKContext"
import { addCurrentQueryParams } from "../../../util"
import { addHitAreaStyle } from "../../../util/styleUtils"
import * as CSS from "csstype"
import { Box, FlexProps, ResponsiveValue } from "@chakra-ui/react"

const logger = new ConsoleLogger()

type Props = {
  joinButtonBackgroundColor?: string
  joinButtonBorderColor?: string
  JoinPageButtonTextColor?: string
  joinButtonMouseoverBackgroundColor?: string
  JoinPageButtonMouseoverTextColor?: string
  navigatedFromiOS?: boolean
  onClick?: () => void | null
  position?: CSS.Property.Position
  top?: ResponsiveValue<CSS.Property.Top>
  left?: ResponsiveValue<CSS.Property.Left>
}

export const BackIconButton = (props : FlexProps  ) => {
  const roomStyles = useRecoilValue(brandingSelector)

  const size = "34px"
  return (
    <Flex
      // padding="6px"
      minW={size}
      minH={size}
      h={size}
      justify="center"
      align={"center"}
      borderRadius="24px"
      cursor="pointer"
      boxShadow={"sm"}
      bg={roomStyles?.joinButtonBackgroundColor ?? "#1AC541"}
      border={
        roomStyles?.joinButtonBorderColor 
          ? `1px solid ${roomStyles?.joinButtonBorderColor}`
          : "0px"
      }
      textColor={roomStyles?.joinPageButtonTextColor ?? "#FFFFFF" }
      _hover={{
        backgroundColor: roomStyles?.joinButtonMouseoverBackgroundColor ??
          "#24A840",
        textColor:
          roomStyles?.joinPageButtonMouseoverTextColor ??
          "#FFFFFF",
        ...props._hover  
      }}

      {...props}
      
    >
      <BiArrowBack size="20px" />
    </Flex>
  )
}

const HomeBackIcon: FC<Props> = ({
  joinButtonBackgroundColor,
  joinButtonBorderColor,
  JoinPageButtonTextColor,
  JoinPageButtonMouseoverTextColor,
  joinButtonMouseoverBackgroundColor,
  navigatedFromiOS = false,
  onClick,
  position = "absolute",
  top = ["9px", null, "19px"],
  left = ["8px", null, "17px"] 
}) => {
  const history = useHistory()
  const navigatedFromShowList = useRecoilValue(navigatedFromShowListAtom)
  const navigatedFromAvatarsList = useRecoilValue(navigatedFromAvatarsListAtom)
  const meetingClient = React.useContext(SDKContext)

  const isJoinButtonLoading = useRecoilValue(joinButtonLoadingSelector)

  // if (!navigatedFromShowList && !navigatedFromAvatarsList && !navigatedFromiOS)
  //   return null

  // disable the back button while joining room is inprogress
  const isButtonDisabled = isJoinButtonLoading

  // Redirect to the '/shows' route or if user is navigated from /shows then replace it
  const goBack = onClick ? onClick : () => {
    if (navigatedFromShowList) history.replace(addCurrentQueryParams(Routes.SHOWS))
    // else if (navigatedFromAvatarsList) history.replace(addCurrentQueryParams(Routes.AVATARS))
    else if (navigatedFromiOS) {
      logger.log("meetingClient?.nativeBridge.eventUserNavigatedBackIntoNativeScreen()")
      meetingClient?.nativeBridge.eventUserNavigatedBackIntoNativeScreen()
    } else {
      history.goBack();
    }
  }

  const styles = {
    ...(joinButtonBackgroundColor && { bg: joinButtonBackgroundColor }),
    ...(joinButtonBorderColor && {border: joinButtonBorderColor ? `1px solid ${joinButtonBorderColor}` : "0px"}),
    ...(JoinPageButtonTextColor && { textColor: JoinPageButtonTextColor }),
    _hover: {
      ...(joinButtonMouseoverBackgroundColor && { backgroundColor: joinButtonMouseoverBackgroundColor }),
      ...(JoinPageButtonMouseoverTextColor && { textColor: JoinPageButtonMouseoverTextColor })
    }
  };

  return (
    <BackIconButton
      pos={position}
      top={top}
      left={left}
      borderWidth={"1px"}
      onClick={isButtonDisabled ? null : goBack}
      opacity={isButtonDisabled && 0.25}
      {...styles}
      // {...addHitAreaStyle()}
    />
  )
}

export default HomeBackIcon
